/**
 * Generated by orval 🍺
 * Do not edit manually.
 * FastAPI
 * OpenAPI spec version: 0.1.0
 */

/**
 * Optional list of URLs or text content to ground the research
 */
export type ContentStudioStage1RequestResources = string[] | null;
